// 十大股东内容
<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg"></div>
    <div class="box">

        <div class="time">更新时间：{{time}}</div>
        <div class="dropdown">
            <el-dropdown @command='handleSelectName' placement="left-start">
            <span class="el-dropdown-link">
                {{selectup}}
            <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <div>
                <el-dropdown-menu slot="dropdown" trigger='click'>
                        <div class="drop_menu">
                            <div v-for="(list,i) in select">
                            <!-- command绑定i来判断是哪一个下拉 -->
                            <el-dropdown-item :command=i>
                                {{list.title}}
                            </el-dropdown-item>
                        </div>
                        </div>
                </el-dropdown-menu>
            </div>
        </el-dropdown>
        </div>
    <div>
  <el-table :data="tableData" stripe class="table" show-summary>
    <el-table-column prop="name" label="股份名称" ></el-table-column>
    <el-table-column :prop=selectdown  :label=selectup align="right" ></el-table-column>
  </el-table>
    </div>
    </div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import api from '@/utils/api'
export default {
  name: 'tenInvestors',
  components: {
    Logo,
  },
  data () {
    return {
      image: '',
      selectup: '股东性质',
      selectdown: 'nature',
      time: '',
      tableData1: [{
        name: '陆峰',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '北京倍量机电有限公司',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '陆峰',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '陆峰',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '陆峰',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '北京倍量机电有限公司',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '陆峰',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '陆峰',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '陆峰',
        nature: '其他',
        count: '125215',
        rate: '13%',
        change: '1-1',
      }, {
        name: '合计',
        nature: ' ',
        count: '125215',
        rate: '13%',
        change: '1-1',
      },
      ],
      tableData: [],
      select: [
        { title: '股东性质', part: 'nature' },
        { title: '持股数量(股)', part: 'count' },
        { title: '持股比例(%)', part: 'rate' },
        { title: '较上期变动(股)', part: 'change' },
      ],
    }
  },
  created () {
    if (window.localStorage.getItem('investor')) {
      var image1 = JSON.parse(window.localStorage.getItem('investor'))
      this.image = image1.data.data.image
    }
    this.getInvestors()
  },
  methods: {
    async getInvestors () {

      const { data: res } = await api.getInvestors()
      if (res.code === 200) {
        //更新时间
        this.time = res.data[0].update_date
        //十大股东
        this.tableData = res.data[0].detail
        console.log(res.data[0].detail)
      }
    },
    handleSelectName (command) {
      this.selectup = this.select[command].title,
        this.selectdown = this.select[command].part
    }
  },
}
</script>

<style >
.el-dropdown-menu {
  left: auto !important;
  right: 0rem;
}
</style>
<style>
.el-table .cell {
  line-height: 2.1rem !important;
}
</style>
<style scoped>
/* 选择菜单设置 */
/deep/ .el-dropdown-menu__item {
  color: #333333 !important;
  font-size: 1.75rem;
  margin-top: 1.5rem;
}
/* 选择菜单位置定义 */
/deep/ .drop_menu {
  margin-top: 1.75rem;
  margin-bottom: 2rem;
  text-align: left;
}
/* table的内部样式 */
/deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell {
  font-size: 1.5rem;
  color: #333333;
}
.dropdown {
  float: right;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  color: #333333;
  font-size: 1.75rem;
}
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.box {
  width: 43.875rem;
  height: 30.875rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4.625rem;
}

/* 标题背景设置 */
/deep/ .el-table th.el-table__cell {
  background-color: #f5f5f5;
  border-bottom-color: #015aaa !important;
  color: #015aaa;
  font-size: 1.75rem;
}
/* 斑马条纹颜色 */
/deep/
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: #f5f5f5;
}
/* 下拉菜单样式 */
.el-dropdown-link {
  cursor: pointer;
}
.el-dropdown {
  font-size: 1.75rem;
}
.el-icon-arrow-down {
  font-size: 1.75rem;
}
/* 表格样式 */
.table {
  /* display: flex */
}
.time {
  font-size: 1.375rem;
  color: #999999;
}
</style>